import script from "./OnboardingIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingIntro.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingIntro.vue?vue&type=style&index=0&id=aa0827da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa0827da"]])

export default __exports__